import { Box, Checkbox, makeStyles, Tooltip } from '@freighthub/silhouette-core'
import { FC, ReactNode } from 'react'
import { useI18n } from 'utils/localisation'

type SelectGroupProps = {
  options: string[]
  selectedOptions?: string[]
  selected?: string
  multiple?: boolean
  iconMap: { [key in string]: ReactNode }
  tooltipMap: { [key in string]: string }
  onToggleOption: (option: string, checked?: boolean) => void
  className?: string
}

const useStyles = makeStyles({
  icon: {
    width: 36,
    height: 36,
  },
})

export const SelectGroup: FC<SelectGroupProps> = ({
  selected,
  selectedOptions,
  multiple,
  options,
  iconMap,
  tooltipMap,
  onToggleOption,
  className,
  ...props
}) => {
  const classes = useStyles()
  const { translate } = useI18n()

  const isSelected = (option: string) => {
    if (multiple) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      return selectedOptions.indexOf(option) !== -1
    }
    return option === selected
  }

  return (
    <Box display="flex" alignItems="center" className={className} {...props}>
      {options.map((option) => (
        <Tooltip key={option} title={translate(tooltipMap[option])}>
          <Checkbox
            value={option}
            checked={isSelected(option)}
            icon={iconMap[option]}
            checkedIcon={iconMap[option]}
            onChange={({ target: { checked } }) => onToggleOption(option, checked)}
            className={classes.icon}
            inputProps={{
              'aria-label': `${option}-icon-button`,
            }}
          />
        </Tooltip>
      ))}
    </Box>
  )
}
